<template>
  <section class="sponsors-section">
    <div class="sponsor-logos">
      <template v-for="(sponsor, index) in sponsors" :key="index">
        <a v-if="sponsor.url" :href="sponsor.url" target="_blank" rel="noopener noreferrer">
          <img :src="sponsor.logo" :alt="sponsor.name">
        </a>
        <img v-else :src="sponsor.logo" :alt="sponsor.name">
      </template>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import sponsor1 from '@/assets/partners/sponsor-1.svg';
import sponsor2 from '@/assets/partners/sponsor-2.svg';
import sponsor3 from '@/assets/partners/sponsor-3.svg';
import sponsor4 from '@/assets/partners/sponsor-4.svg';
import sponsor5 from '@/assets/partners/sponsor-5.svg';
import sponsor6 from '@/assets/partners/sponsor-6.png';
// Add more sponsor logos as needed

const { locale } = useI18n();

const sponsors = computed(() => [
  { name: 'Sponsor 1', logo: sponsor1 },
  { 
    name: 'Sponsor 2', 
    logo: sponsor2,
    url: locale.value === 'nl'
      ? 'https://www.fondationbernheim.be/nl/projects/'
      : 'https://www.fondationbernheim.be/fr/projects/'
  },
  { 
    name: 'Sponsor 3', 
    logo: sponsor3,
    url: locale.value === 'nl'
      ? 'https://www.nationale-loterij.be/over-ons/onze-engagementen'
      : 'https://www.loterie-nationale.be/a-propos-de-nous/nos-engagements'
  },
  { 
    name: 'Sponsor 4', 
    logo: sponsor4,
    url: locale.value === 'nl'
      ? 'https://www.flagey.be/nl/schoolkoren-fcxq'
      : 'https://www.flagey.be/fr/les-chorales-scolaires-fcxq'
  },
  { 
    name: 'Sponsor 5', 
    logo: sponsor5,
    url: locale.value === 'nl'
      ? 'https://sk-fr-paola.be/nl/de-stichting/'
      : 'https://sk-fr-paola.be/la-fondation/'
  },
  { 
    name: 'Sponsor 6', 
    logo: sponsor6, 
    url: locale.value === 'nl' 
      ? 'https://corporate.totalenergies.be/nl/onze-engagementen-0' 
      : 'https://corporate.totalenergies.be/fr/nos-engagements' 
  },
  // Add more sponsors
]);
</script>

<style scoped>
.sponsors-section {
  padding: 28px 20px;
  border-bottom: 1px solid var(--border-color);
  background-color: #fff;
  text-align: center;
}

.sponsor-logos {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: clamp(14px, 2vw, 28px);
  max-width: var(--content-width);
  margin: 0 auto;
  align-items: center;
}

.sponsor-logos a {
  display: flex;
  min-height: 76px;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: var(--radius-sm);
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.sponsor-logos a:hover {
  background: var(--warm-bg);
  transform: translateY(-2px);
}

.sponsor-logos img {
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  width: auto;
  max-width: 150px;
  height: 58px;
  margin: 0 auto;
  object-fit: contain;
}

@media (max-width: 900px) {
  .sponsor-logos {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 600px) {
  .sponsors-section {
    padding: 22px 12px;
  }

  .sponsor-logos {
    gap: 10px;
  }

  .sponsor-logos img {
    max-width: 100px;
    height: 38px;
  }
}
</style>
